import React from "react";
import { NavigationMenu } from "radix-ui";
import "../ui.css";
import { useDataUiTheme } from "../utility/getDataUiTheme";
export var RadixNavbar = React.forwardRef(function (_a, ref) {
    var brand = _a.brand, actions = _a.actions, children = _a.children, _b = _a.ariaLabel, ariaLabel = _b === void 0 ? "Primary navigation" : _b, className = _a.className, _c = _a.sticky, sticky = _c === void 0 ? false : _c, _d = _a.stickyTop, stickyTop = _d === void 0 ? 0 : _d, _e = _a.layout, layout = _e === void 0 ? "default" : _e;
    var uiTheme = useDataUiTheme();
    var hasNavigationItems = React.Children.count(children) > 0;
    var classes = ["radix-navbar", sticky ? "radix-navbar--sticky" : null, className]
        .filter(Boolean)
        .join(" ");
    var innerClasses = [
        "radix-navbar-inner",
        hasNavigationItems ? null : "radix-navbar-inner--no-nav",
        layout === "brandActions" ? "radix-navbar-inner--brand-actions" : null,
    ]
        .filter(Boolean)
        .join(" ");
    return (React.createElement("header", { ref: ref, className: classes, style: sticky ? { top: "".concat(stickyTop, "px") } : undefined, "data-ui-theme": uiTheme },
        React.createElement("div", { className: innerClasses },
            React.createElement("div", { className: "radix-navbar-brand" }, brand),
            hasNavigationItems ? (React.createElement(NavigationMenu.Root, { "aria-label": ariaLabel, className: "radix-navbar-nav" },
                React.createElement(NavigationMenu.List, { className: "radix-navbar-list" }, children))) : null,
            React.createElement("div", { className: "radix-navbar-actions" }, actions))));
});
RadixNavbar.displayName = "RadixNavbar";
